import { FC } from 'react';
import { Badge } from '@chakra-ui/react';
import { BrandVariable } from '@adflow/types';

type Props = {
  variableType?: BrandVariable | 'none';
};

/**
 * A small badge component that indicates a value comes from the brand kit.
 * Used in Rightsidebar controls to show users which values are brand-derived.
 */
const BrandBadge: FC<Props> = ({ variableType }) => {
  const normalizedNaming = () => {
    switch (variableType) {
      case BrandVariable.PRIMARY_FONT:
        return 'Primary Font';
      case BrandVariable.SECONDARY_FONT:
        return 'Secondary Font';
      case BrandVariable.PRIMARY_COLOR:
      case BrandVariable.SECONDARY_COLOR:
        return 'Brand Color';
      case BrandVariable.LOGO:
      case BrandVariable.BRAND_LOGO:
        return 'Brand Logo';
      default:
        return 'Brand';
    }
  };

  return (
    <Badge colorScheme="purple" variant="subtle" fontSize="xs" px={1.5} py={0.5} borderRadius="sm">
      {normalizedNaming()}
    </Badge>
  );
};

export default BrandBadge;
